import * as rest from './RestUtil';
import * as storage from '../util/StorageUtil';
import { getFunctionBaseUrl } from './RestUrls';
import { ICompany, ICompanyAndBilling, ICompanyBilling, IUserProfile } from '../util/DataModelInterface';

const comparer = (a: any, b: any) => {
  return a.name.localeCompare(b.name);
}

export const getCompanies = async (force: boolean = false) => {
  let companies = storage.getCompanies();
  if (!companies || force) {
    let all = true;
    let archived = false;
    const url = `${getFunctionBaseUrl()}/api/getCompanies/${all}/${archived}/`;
    const response = await rest.get(url);
    companies = response?.result?.length > 0 ? response.result.sort(comparer) : '';
    if(companies) {
      storage.setCompanies(companies);
      return companies as ICompany[];
    }
    else {
      return response;
    }
  }
  return companies as ICompany[];
}

export const getActiveCompanies = async (archived: boolean = false) => {
  let all = false;
  const url = `${getFunctionBaseUrl()}/api/getCompanies/${all}/${archived}/`;
  const response = await rest.get(url);
  let companies = response?.result?.length > 0 ? response.result.sort(comparer) : '';
  if(companies) {
    return companies as ICompany[];
  }
  else {
    return response;
  }
}

export const getCompany = async (id: string) => {
  const url = `${getFunctionBaseUrl()}/api/getCompany/${id}`;
  const response = await rest.get(url);
  return response;
}

export const getCompanyUsers = async (id: string) => {
  const url = `${getFunctionBaseUrl()}/api/getCompanyUsers/${id}/`;
  const response = await rest.get(url);
  let users = response?.result;
  if(users) {
    return users as IUserProfile[];
  }
  else {
    return response;
  }
}

export const archiveCompany = async (company: ICompany) => {
  const url = `${getFunctionBaseUrl()}/api/archiveCompany/`;
  const response = await rest.post(url, company);
  console.log("resp: ", response);
  return response;
}

export const saveCompany = async (company: ICompanyAndBilling) => {
  const url = `${getFunctionBaseUrl()}/api/saveCompany/`;
  const response = await rest.post(url, company);
  return response;
}

export const getCompanyBilling = async (id: number = 0) => {
  const url = `${getFunctionBaseUrl()}/api/getCompanyBilling/${id}`;
  const response = await rest.get(url);
  let billing = response;
  return billing as ICompanyBilling;
}

export const addCompany = async (company: ICompanyAndBilling) => {
  const url = `${getFunctionBaseUrl()}/api/addCompany/`;
  const response = await rest.post(url, company);
  return response;
}

export const exportCompanies = async (data: any) => {
  const url = `${getFunctionBaseUrl()}/api/exportCompanyList/`;
  const response = await rest.exporting(url, data);
  return response;
}